export const REDUCER_INDEX = 'triggers';

export const BASE_URL = 'triggers';

export const TRIGGERS_LIST_VIEW_STORAGE_KEY = 'triggersList';

export const PATHS = {
  BASE_URL,
  CREATE_TRIGGER: `${BASE_URL}/create`,
  EDIT_TRIGGER: `${BASE_URL}/edit/:triggerId`,
} as const;

export const getRouteToEditTrigger = (triggerId: string): string =>
  PATHS.EDIT_TRIGGER.replace(':triggerId', triggerId);

export const getRouteToCreateTrigger = (): string => PATHS.CREATE_TRIGGER;

export const goRouteToTriggers = (): string => BASE_URL;
